export default __webpack_public_path__ + "static/media/btn_chatea_az.d8824961.png";